import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "user-picture" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 1,
  class: "no-picture"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-user-circle-o",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from 'vue'

  import { IUserProfile } from '@/types/user'
  import { getApiUrl } from '@/utils'

  interface Props {
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
  }

  

  const authUserPictureUrl = computed(() =>
    props.user.picture
      ? `${getApiUrl()}users/${props.user.username}/picture`
      : ''
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(authUserPictureUrl) !== '')
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "profile-user-img",
          alt: _ctx.$t('user.USER_PICTURE'),
          src: _unref(authUserPictureUrl)
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}
}

})